export default __webpack_public_path__ + "static/media/Familles.05d16603.xlsx";